import React from 'react';
import clsx from 'clsx';
import { TooltipReact } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import styles from './_setting.module.styl';
type ExperimentPageConfigurationSettingProps = {
  label?: string;
  helpText?: string;
  children: React.ReactNode;
};
export function ExperimentPageConfigurationSetting(props: ExperimentPageConfigurationSettingProps) {
  return <div className={styles.setting} data-sentry-component="ExperimentPageConfigurationSetting" data-sentry-source-file="_setting.tsx">
      {props.label ? <div className={clsx(styles.label, {
      [styles.withTooltip]: !!props.helpText
    })}>
          {props.label}

          {props.helpText && <TooltipReact placement={Placement.RightCenter} text={props.helpText} maxWidth={"260px"} />}
        </div> : null}
      <div className={styles.entry}>{props.children}</div>
    </div>;
}